export default __webpack_public_path__ + "static/media/other-shipment-light.58a081e7.svg";